module.exports = __webpack_public_path__ + "static/media/dashboard-right-arrow.89333aad.png";